/*
 * File: OrdersPageToolbar.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: The toolbar which displays the refresh and filter icons
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Toolbar, IconButton } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import RefreshIcon from "@material-ui/icons/Refresh";
import PropTypes from "prop-types";
import OrdersAppStore from "services/orders/store/models/OrdersAppStore";
import { useStore } from "utils/useStore";

const styles = theme => ({
  icon: {
    color: theme.palette.common.white
  },
  toolbar: {
    padding: `0 ${theme.spacing(0.5)}px`,
    justifyContent: "flex-end",
    backgroundColor: theme.palette.primary.main
  }
});

const OrdersPageToolbar = ({ classes, toggleFilterDialog }) => {
  const store = useStore(OrdersAppStore);
  return (
    <Toolbar className={classes.toolbar}>
      <IconButton
        onClick={() => store.refreshOrders()}
        id="icon-order-refresh"
        className={classes.icon}
      >
        <RefreshIcon />
      </IconButton>
      <IconButton
        onClick={toggleFilterDialog}
        id="icon-order-filters"
        className={classes.icon}
      >
        <FilterListIcon />
      </IconButton>
    </Toolbar>
  );
};

OrdersPageToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleFilterDialog: PropTypes.func.isRequired
};

export default withStyles(styles)(OrdersPageToolbar);
